import { WizardContainerComponentProps } from '../wizard-container.model';
import { AddScreenController } from './add-screen.controller';

const AddScreen = (props: WizardContainerComponentProps): JSX.Element => {
  return <AddScreenController {...props} />;
};
export default AddScreen;
